import React, { Component } from 'react'

class ModifierInputWithoutValidation extends Component {

  render () {
    const {props} = this
    return <div className='form-group'>
      <input type='text' {...props} {...props.input} />
    </div>
  }

}

export default ModifierInputWithoutValidation



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierInputWithoutValidation.js